import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TokenRefresh } from './tokenRefresh_service';
import { StoreData } from '../utils/store_data';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PageSize } from '../enumeration/pageSize';

@Injectable({
  providedIn: 'root',
})
export class SurveyServices {

  http: HttpClient = inject(HttpClient);
  store: StoreData = inject(StoreData);
  service: TokenRefresh = inject(TokenRefresh);

  //PERMISSION=SUPER_ADMIN/ADMIN/DEALER
  getSurveyList(page: any, pageSize: any): Observable<any> {
    const httpOptions = this.getHeaders()
    return this.http.get<any>(environment.baseUrl + 'api/drapp/surveys/listsurveyinfo?page=' + page + '&pageSize=' + pageSize, httpOptions)
  }

  //PERMISSION=SUPER_ADMIN/ADMIN
  getCreateSurvey(name: any, startDate: any, endDate: any, period: any) {
    const httpOptions = this.getHeaders()
    return this.http.post<any>(environment.baseUrl + 'api/drapp/surveys/create?name=' + name + '&startDate=' + startDate + '&endDate=' + endDate + '&period=' + period, null, httpOptions)
  }

  removeSurveyFormStatus(surveyId: any) {
    const httpOptions = this.getHeaders()
    return this.http.post<any>(environment.baseUrl + 'api/drapp/surveys/remove?surveyId=' + surveyId, null, httpOptions)
  }

  getSurveyInfo(surveyId: any) {
    const httpOptions = this.getHeaders()
    return this.http.get<any>(environment.baseUrl + 'api/drapp/surveys/surveyinfo?surveyId=' + surveyId, httpOptions)
  }

  createTitle(surveyId: any, title: string) {
    const httpOptions = this.getHeaders()
    return this.http.post<any>(environment.baseUrl + 'api/drapp/surveys/sectiontitles?surveyId=' + surveyId + '&title=' + title , null, httpOptions)
  }

  updateTitle(sectionTitleId: any, title: any) {
    const httpOptions = this.getHeaders()
    return this.http.post<any>(environment.baseUrl + 'api/drapp/surveys/update/sectiontitles?sectionTitleId=' + sectionTitleId + '&title=' + title, null, httpOptions)
  }

  createSectionTitle(surveyId: any, sectionTitleId: any, subTitle: any, description: any) {
    const httpOptions = this.getHeaders()
    return this.http.post<any>(environment.baseUrl + 'api/drapp/surveys/sections?surveyId=' + surveyId + '&sectionTitleId=' + sectionTitleId + '&subTitle=' + subTitle + '&description=' + description, null, httpOptions)
  }

  updateSectionTitle(sectionId: any, sectionTitleId: any, subTitle: any, description: any) {
    const httpOptions = this.getHeaders()
    return this.http.post<any>(environment.baseUrl + 'api/drapp/surveys/update/sections?sectionId=' + sectionId + '&sectionTitleId=' + sectionTitleId + '&subTitle=' + subTitle + '&description=' + description, null, httpOptions)
  }

  createQuestion(sectionId: any, questionTextMy: any, questionTextEng: any) {
    const httpOptions = this.getHeaders()
    return this.http.post<any>(environment.baseUrl + 'api/drapp/surveys/questions?sectionId=' + sectionId + '&questionTextMy=' + questionTextMy + '&questionTextEng=' + questionTextEng, null, httpOptions)
  }

  updateQuestion(questionId: number | null, questionTextMy: any, questionTextEng: any) {
    const httpOptions = this.getHeaders()
    return this.http.post<any>(environment.baseUrl + 'api/drapp/surveys/update/questions?questionId=' + questionId + '&questionTextMy=' + questionTextMy + '&questionTextEng=' + questionTextEng, null, httpOptions)
  }

  deleteQuestion(questionId: any) {
    const httpOptions = this.getHeaders()
    return this.http.post<any>(environment.baseUrl + 'api/drapp/surveys/remove/questions?questionId=' + questionId, null, httpOptions)
  }

  updateSurveyFormStatus(surveyId: any, status: string) {
    const httpOptions = this.getHeaders()
    return this.http.post<any>(environment.baseUrl + 'api/drapp/surveys/status?surveyId=' + surveyId + '&status=' + status, null, httpOptions)
  }

  getRatingInfoLst() {
    const httpOptions = this.getHeaders()
    return this.http.get<any>(environment.baseUrl + 'api/drapp/surveys/listratinginfo', httpOptions)
  }

  getSubmitSurvey(requestBody: { surveyId: any; suggestions: string; answers: any[]; }) {
    const httpOptions = this.getHeaders()
    return this.http.post<any>(environment.baseUrl + 'api/drapp/surveys/submit', JSON.stringify(requestBody), httpOptions)

  }

  getSurveyInfoByDealer(surveyId: any, dealerLoginName: any) {
    const httpOptions = this.getHeaders()
    return this.http.get<any>(environment.baseUrl + 'api/drapp/surveys/surveyinfobydealer?surveyId=' + surveyId + '&dealerLoginName=' + dealerLoginName, httpOptions)
  }

  getDealerBySurvey(surveyId: any, page: number, pageSize: PageSize) {
    const httpOptions = this.getHeaders()
    return this.http.get<any>(environment.baseUrl + 'api/drapp/surveys/listdealerbysurvey?surveyId=' + surveyId + '&page=' + page + '&pageSize=' + pageSize, httpOptions)
  }

  getHeaders() {
    var result = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': this.store.getAuth(),
      }),
      withCredentials: true
    }
    return result;
  }
}
